<template>
  <div class="main jc-center">
    <div class="content">
      <h1>合作伙伴</h1>
      <div class="flex wrap">
        <img v-for="(item, index) in list" :key="index" :src="item.picture" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: { info: Object },
  data() {
    return {
      list: [],
    };
  },
  watch: {
    info: {
      handler(val) {
        this.list = val.wxSchoolPageItemList;
      },
      deep: true,
    },
  },
  mounted() {
    this.list = this.info.wxSchoolPageItemList;
  },
};
</script>
<style lang="less" scoped>
.main {
  background: #fafafa;
  .content {
    width: 1200px;
    text-align: center;
    padding: 48px 0;
    h1 {
      font-size: 32px;
      margin-bottom: 40px;
      font-weight: 600;
    }
    img {
      width: 180px;
      height: 80px;
      margin-right: 24px;
      margin-bottom: 16px;
      &:nth-child(6n + 6) {
        margin-right: 0;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/designPage/template/other/other2/index.vue